import {Component, inject, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import {select, Store} from "@ngrx/store";
import {AppState} from "../../../store/reducers";
import {Observable} from "rxjs";
import {
  PrivacyPolicyTermsCondition
} from "../../../store/entities/cms/privacy-policy-terms-condition/privacy-policy-terms-condition.model";
import {StoreItemActions} from "../../../store/entities/store-item/store-item.actions";
import {StoreItemEntity} from "../../../store/entities/store-item/store-item.model";
import {
  GET_PRIVACY_POLICY,
  GET_TERMS_CONDITION
} from "../../../store/entities/cms/privacy-policy-terms-condition/privacy-policy-terms-condition.graphql";
import {selectStoreItems} from "../../../store/entities/store-item/store-item.selectors";

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {

  store = inject(Store<AppState>);
  privacyPolicyTermsCondition$: Observable<PrivacyPolicyTermsCondition[]>;
  title='Sera ya faragha'
  constructor(private location: Location) {
  }

  ngOnInit() {
    this.store.dispatch(StoreItemActions.getStoreItemsMergeMap({
      entity: StoreItemEntity.privacyPolicyTermsCondition,
      query: GET_PRIVACY_POLICY,
      filtering: {}
    }))

    this.privacyPolicyTermsCondition$ = this.store.pipe(select(selectStoreItems(StoreItemEntity.privacyPolicyTermsCondition)))
  }

  goBack() {
    this.location.back()
  }

}
